import GeosuggestInput from './GeosuggestInput';

export default GeosuggestInput;
